import { BpSpinner } from '~/elements/BpSpinner'

interface WelcomeScreenProps {
  onComplete: () => void
}

export function WelcomeScreen({ onComplete }: WelcomeScreenProps) {
  // Auto-redirect after 3 seconds
  setTimeout(() => {
    onComplete()
  }, 3000)

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-6 bg-black px-4 md:gap-8">
      <h2 className="text-center text-2xl font-normal text-white md:text-4xl">Welcome to Botpress.</h2>

      <div className="relative flex h-[250px] w-[250px] items-center justify-center overflow-hidden rounded-[20px] shadow-2xl shadow-white/20 md:h-[400px] md:w-[400px]">
        <img
          src="/background/bp_gradient-min.png"
          alt="Welcome BP Gradient"
          className="h-auto w-full"
          style={{ transform: 'rotate(90deg)', transformOrigin: 'center center' }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative animate-pulse rounded-xl bg-gradient-to-br from-purple-600/20 via-blue-500/20 to-cyan-400/20 p-6 backdrop-blur-2xl">
            <div className="absolute inset-0 animate-pulse rounded-xl bg-gradient-to-br from-purple-600 via-blue-500 to-cyan-400 opacity-20 blur-xl" />
            <BpSpinner className="h-30 w-30 relative z-10 text-white opacity-70" />
          </div>
        </div>
      </div>

      <p className="text-center text-xs font-light text-neutral-400 md:text-sm">
        You will be redirected to your workspace
      </p>
    </div>
  )
}
